// src/pages/Admin/VotePage/ui/VoteActionButton.jsx

import React from "react";

const VARIANTS = {
  default:
    "border-slate-200 bg-white text-slate-700 hover:border-slate-300 hover:bg-slate-50 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200 dark:hover:bg-slate-800",

  indigo:
    "border-indigo-600 bg-indigo-600 text-white hover:border-indigo-700 hover:bg-indigo-700",

  violet:
    "border-violet-600 bg-violet-600 text-white hover:border-violet-700 hover:bg-violet-700",

  danger:
    "border-rose-100 bg-rose-50 text-rose-700 hover:border-rose-200 hover:bg-rose-100 dark:border-rose-500/20 dark:bg-rose-500/10 dark:text-rose-300 dark:hover:bg-rose-500/20",
};

export default function VoteActionButton({
  icon: Icon,
  label,
  variant = "default",
  compact = false,
  disabled = false,
  onClick,
  title,
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      title={title || label}
      className={`inline-flex h-9 items-center justify-center gap-2 rounded-xl border px-3 text-xs font-black transition disabled:cursor-not-allowed disabled:opacity-50 ${
        VARIANTS[variant] || VARIANTS.default
      }`}
    >
      <Icon className={disabled ? "animate-pulse" : ""} />

      {!compact && <span>{label}</span>}
    </button>
  );
}